import '../../componentiba/AgentPersonalDetails/AgentPersonalDetails.scss';
import { useEffect, useState } from 'react';
import SingleSignOnSideBar from "../../../../../src/Components/SingleSignOnSideBar"
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import Header from '../../../../Components/Header';
import { formatDate } from '../../../../CommonMethhods/CommonMethods';
import axios from 'axios';

const AgentPersonalDetailsComp = () => {
    const userId = localStorage.getItem("userId");
    const [agentsDetails, setAgentsDetails] = useState({})

    const agentAllDetails = async () => {
        const payload = {
            sapcode: userId
        }
        try {
            const response = await axios.post(
                IBA_Admin_Section.agentPersonalDetails,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        reserv: 0,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response?.data;
            if (data.status === 0) {
                setAgentsDetails(data?.data);
            } else {
                setAgentsDetails([]);
            }
        } catch (err) {
            console.log(err);
            setAgentsDetails([]);
        }
    };

    useEffect(() => {
        agentAllDetails()
    }, []);

    const getInitials = (name = "") => {
        if (!name) return "";
        const words = name.trim().split(/\s+/);
        const firstInitial = words[0]?.charAt(0).toUpperCase() || "";
        const lastInitial = words.length > 1 ? words[words.length - 1].charAt(0).toUpperCase() : "";
        return `${firstInitial}${lastInitial}`;
    };

    console.log(agentsDetails, "agentsDetails");



    return (
        <div>
            <Header portal={"IBA"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="telecallerDash">
                <div className='card-box iba-page'>
                    <div className="agent-table-wrapper">
                        <div className="wrap-header ag-detail">
                            <div className='module-title'>Personal Details</div>
                        </div>

                        <div className='mt-4'>

                            <div className="agent-info-card">
                                <div className="left">
                                    {agentsDetails?.Personal?.AgentName ?
                                        <div className="avatar-text">
                                            {getInitials(agentsDetails?.Personal?.AgentName)}
                                        </div>
                                        :
                                        <span className='no-icon'>N/A</span>}

                                    <div className="agent-details">
                                        <div className="name">{agentsDetails?.Personal?.AgentName || "-"}</div>
                                        <div className="role">Agent</div>
                                    </div>
                                </div>

                                <div className="middle agent-middle">
                                    <div><strong>User ID:</strong> <span className="link header-sec">{agentsDetails?.Personal?.sapCode || "-"}</span></div>
                                    <div><strong>Phone Number:</strong> <span className="link header-sec">{agentsDetails?.Personal?.PhoneNumber || "-"}</span></div>
                                    <div><strong>Password:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TeamLeader || "-"}</span></div>
                                    <div><strong>Team Lead:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TierName || "-"}</span></div>
                                </div>

                             </div>

                                <div className='personal-card agent-pd'>

                                    <div className="personal-details-card">
                                        <div className="card-head">
                                            <div className="card-header">Personal Details</div>
                                        </div>

                                        <div className="detail-row">
                                            <span className="label">Full Name:</span>
                                            <span className="value">{agentsDetails?.Personal?.AgentName || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">DOB:</span>
                                            <span className="value">{(agentsDetails?.Personal?.DOB) ? formatDate(agentsDetails?.Personal?.DOB) : '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">Email-ID:</span>
                                            <span className="value">{agentsDetails?.Personal?.email || '-'}</span>
                                        </div>

                                        <div className="detail-row">
                                            <span className="label">DOJ:</span>
                                            <span className="value">{agentsDetails?.Personal?.Address || '-'}</span>
                                        </div>

                                        <div className="detail-row">
                                            <span className="label">Aadhaar:</span>
                                            <span className="value">{agentsDetails?.Personal?.Aadhar || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">PAN:</span>
                                            <span className="value">{agentsDetails?.Personal?.PAN || '-'}</span>
                                        </div>
                                    </div>


                                    <div className="personal-details-card">
                                        <div className="card-head">
                                            <div className="card-header">Bank Details</div>
                                            {/* <img src={detailsEdit} style={{cursor:"pointer"}} alt="detailsEdit" onClick={openEditModal} /> */}
                                        </div>

                                        <div className="detail-row">
                                            <span className="label">Account Number:</span>
                                            <span className="value">{agentsDetails?.Personal?.AccountNumber || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">IFSC Code:</span>
                                            <span className="value">{agentsDetails?.Personal?.IFSCCode || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">MICR:</span>
                                            <span className="value">{agentsDetails?.Personal?.MICRCode || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">Branch Name:</span>
                                            <span className="value">{agentsDetails?.Personal?.BranchName || '-'}</span>
                                        </div>
                                        <div className="detail-row">
                                            <span className="label">Branch Address:</span>
                                            <span className="value">{agentsDetails?.Personal?.BranchAddress || '-'}</span>
                                        </div>  

                                    </div>


                                    {/* <PersonalAndBank selectedAgent={agentsDetails} />
                                <IbaBank selectedAgent={agentsDetails} /> */}

                                </div>

                           
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default AgentPersonalDetailsComp;
